<template>
  <div>
    <div class="card">
      <router-link :to="`/${cardData.id}/page`">
        <div class="image-cover">
          <img :src="cardData.title_thumb" @contextmenu.prevent alt="cover image" />
        </div>
        <div class="overlay">
          <div class="details-card">
            <h3 class="title-project">Sinopse</h3>
            <p>{{ cardData.description }}</p>
          </div>
          <div class="footer-card">
            <ul class="list-genere">
              <li>{{ cardData.project.category.name }}</li>
              <li>{{ cardData.project.type.name }}</li>
            </ul>
            <div class="rating-container">
              <div class="rating">
                <div>{{ cardData.project.likes_count }}</div>
                <v-icon color="white" class="custom-icon">mdi-heart</v-icon>
              </div>
              <div class="rating">
                <div>{{ cardData.views }}</div>
                <v-icon color="white">mdi-eye</v-icon>
              </div>
            </div>
          </div>
        </div>
      </router-link>
    </div>
    <div class="h1-container">
      <h1 ref="title" :class="{ marquee: isOverflowing }">
        | {{ cardData.name }}
      </h1>
    </div>
    <h4>{{ cardData.project.language.name }} / {{ cardData.project.gender.name }}</h4>
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from "vue";

export default {
  name: "SimpleCardTest",
  props: {
    cardData: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const title = ref(null);
    const isOverflowing = ref(false);

    onMounted(() => {
      nextTick(() => {
        if (title.value) {
          isOverflowing.value = title.value.scrollWidth > title.value.clientWidth;
        }
      });
    });

    return { title, isOverflowing };
  },
};
</script>





<style scoped>
h1,
h4 {
  color: #fff !important;
}

h1 {
  font-size: x-large;
  font-weight: 600;
}

h4 {
  font-weight: 400;
  margin-left: 14px;
}

.h1-container {
  width: 250px; /* Defina o tamanho máximo */
  overflow: hidden;
  white-space: nowrap;
  position: relative;
  display: flex;
  align-items: center;
}

.h1-container h1 {
  display: inline-block;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}


.v-application ul,
.v-application ol {
  padding-left: 0px;
}

.rating-container {
  display: flex;
  gap: 12px;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
}

p {
  color: #fff !important;
}

.card {
  position: relative;
  width: 258px;
  height: 400px;
  border-radius: 2px;
  cursor: pointer;
  overflow: hidden;
  transition: transform 0.3s ease;
}

.card:hover {
  transform: scale(1.02);
}

.image-cover {
  width: 100%;
  height: 100%;
  /* Assegura que a altura da imagem seja sempre 100% do card */
  overflow: hidden;
}

.image-cover img {
  width: 100%;
  height: 100%;
  /* Garante que a imagem ocupe 100% de altura */
  object-fit: cover;
  /* Garante que a imagem ocupe 100% do espaço sem distorcer */
  transition: opacity 0.3s ease;
}


.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.836);
  color: white;
  opacity: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 16px;
  transition: opacity 0.3s ease;
}

.card:hover .overlay {
  opacity: 1;
}

.title-project {
  font-size: 16px;
  font-weight: bold;
  text-align: center;
}

.details-card {
  font-size: 14px;
  color: #ccc;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease, opacity 0.3s ease;
}

.card:hover .details-card {
  max-height: 500px;
  opacity: 1;
}

.list-genere {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 5px;
}

.list-genere li {
  list-style: none;
  padding: 4px 10px;
  background-color: var(--zinnes-primary);
  border-radius: 5px;
  font-size: 12px;
}

.footer-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}

.rating {
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 2px;
  padding: 4px;
}

.custom-icon {
  color: #ffcc00;
}

@media (max-width: 520px) {
  h1 {
    font-size: 16px;
  }

  h4 {
    font-size: 8px;
  }

  .card {
    width: 120px !important;
    height: 220px !important;
  }

  .h1-container {
    width: 135px !important;
  }

  .title h3 {
    font-size: 12px;
  }

  .footer-card {
    flex-direction: column;
    align-items: center;
  }

  .rating {
    width: auto;
    height: 20px;
  }

  .custom-icon {
    font-size: 14px;
  }
}

@media (max-width: 1024px) {
  .card {
    width: 200px;
    height: 320px;
  }

  .h1-container {
    width: 195px !important;
  }
}

@media (max-width: 768px) {
  .card {
    width: 120px !important;
    height: 220px !important;
  }

  .h1-container {
    width: 115px !important;
  }

  h1 {
    font-size: 14px;
  }
}

@media (max-width: 860px) {
  .h1-container {
    width: 215px !important;
  }

  h1 {
    font-size: 18px;
  }

  .card {
    width: 220px !important;
    height: 330px !important;
  }
}

@media (max-width: 425px) {
  .card {
    width: 120px !important;
    height: 220px !important;
  }

  .h1-container {
    width: 185px !important;
  }
}

@media (max-width: 395px) {
  .card {
    width: 120px !important;
    height: 220px !important;
  }

  .h1-container {
    width: 135px !important;
  }
}

@media (max-width: 375px) {
  .card {
    width: 120px !important;
    height: 220px !important;
  }

  .h1-container {
    width: 145px !important;
  }
}

@media (max-width: 350px) {
  .card {
    width: 120px !important;
    height: 220px !important;
  }

  .h1-container {
    width: 135px !important;
  }
}


@media (max-width: 320px) {
  .card {
    width: 120px !important;
    height: 220px !important;
  }

  .h1-container {
    width: 135px !important;
  }
}

@media (max-width: 1440px) {
  .card {
    width: 230px;
    height: 380px;
  }

  .h1-container {
    width: 225px !important;
  }

}
</style>
